import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { AuthenticationService } from '../../../services/common/authentication.service';
import { PersistentStorageService } from '../../../services/common/persistent-storage.service';
import { SidebarService } from '../../../services/student-services/common/sidebar.service';
import { USER_KEY } from '../../../constants/user-constants';

@Component({
	selector: 'app-header-student',
	templateUrl: './header-student.component.html',
	styleUrls: [ './header-student.component.scss' ]
})
export class HeaderStudentComponent implements OnInit {
	@Input() currentUser;
	// @Input() viewOnlyData;
	@Input() viewOnlyFlag;
	@Output() studentChosen = new EventEmitter<string>();
	@Output() navigation = new EventEmitter<string>();

	constructor(
		private readonly router: Router,
		private readonly auth: AuthenticationService,
		private readonly persistentStorageService: PersistentStorageService,
		private readonly location: Location,
		private readonly SidebarService: SidebarService
	) {}
	showLogout: boolean = false;
	studentsDropdown: any[];
	studentEmail: string;
	studentName: string;
	showSidebar: boolean = false;
	showNavList: boolean = false;
	showOnboardingIcon: boolean;

	ngOnInit() {
		this.SidebarService.isSidebarActive.subscribe((isSidebarData: boolean) => {
			this.showSidebar = isSidebarData;
		});
		this.studentEmail = this.persistentStorageService.getLocalStorage(USER_KEY.CURRENT_STUDENT_EMAIL);
	}

	public getSelectedStudentName() {
		this.studentName = this.studentsDropdown.find((student) => student.upn === this.studentEmail).display_name;
	}

	public onStudentSelect(studentEmail) {
		this.getSelectedStudentName();
		this.navigateTo('student');
		this.studentChosen.emit(studentEmail);
	}

	public viewDropdown() {
		this.showLogout = !this.showLogout;
	}

	public onClickedOutside(e: Event) {
		this.showLogout = false;
		this.showNavList = false;
	}

	/**
   * @description navigate the page to settings page.
   */
	public navigateToSettings() {
		this.showLogout = false;
		this.router.navigate([ './settings' ]);
	}
	/**
  * @description logout functionality
  */
	public logout() {
		this.persistentStorageService.removeLocalStorage(USER_KEY.CURRENT_STAFF_EMAIL);
		this.persistentStorageService.removeLocalStorage(USER_KEY.CURRENT_STUDENT_EMAIL);
		this.auth.logout();
	}
	public navigateTo(path: string) {
		this.showNavList = false;
		this.showLogout = false;
		this.location.replaceState(`/${path}`);
		this.navigation.emit(path);
	}
	public toggleSidebar() {
		this.showSidebar = !this.showSidebar;
		this.SidebarService.isSidebarActive.next(this.showSidebar);
		this.showNavList = false;
		if (this.viewOnlyFlag) {
			this.location.replaceState(`/checklist`);
			this.navigation.emit('checklist');
		} else {
			this.location.replaceState(`/student`);
			this.navigation.emit('student');
		}
	}
	public toggleNav() {
		this.showNavList = !this.showNavList;
		this.showSidebar = false;
		this.SidebarService.isSidebarActive.next(this.showSidebar);
	}
}
